<template>
  <div class="slide">
    <div class="image-wrapper" @click="openZoom">
      <Zoom class="zoom" />
      <img :src="image" loading="lazy" class="image" />
    </div>

    <div class="description">
      <p class="text">{{ text }}</p>
      <h4 class="title">{{ title }}</h4>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Zoom from "@/assets/icons/zoom.svg";

export default {
  name: "PartnerSlide",
  components: { Zoom },
  props: {
    image: { type: String, required: true },
    text: { type: String, required: true },
    title: { type: String, required: true },
  },
  data() {
    return {
      zoomInstance: null,
    };
  },
  methods: {
    openZoom() {
      if (this.zoomInstance) return;

      const ZoomComponent = Vue.extend({
        render: (h) =>
          h(
            "div",
            {
              class: "overlay",
              on: { click: this.closeZoom },
            },
            [
              h("img", {
                attrs: {
                  src: this.image,
                },

                class: "image zoomed",
              }),
            ],
          ),
      });

      this.zoomInstance = new ZoomComponent();
      this.zoomInstance.$mount();
      document.body.appendChild(this.zoomInstance.$el);
    },
    closeZoom() {
      if (!this.zoomInstance) return;
      document.body.removeChild(this.zoomInstance.$el);
      this.zoomInstance.$destroy();
      this.zoomInstance = null;
    },
  },
};
</script>

<style lang="less">
.slide {
  display: flex;
  align-items: center;
  @media (max-width: 1439px) {
    gap: 24px;
  }
  @media (max-width: 767px) {
    flex-direction: column;
  }

  .image-wrapper {
    position: relative;
    cursor: pointer;
    .zoom {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 10;
    }
    .image {
      width: 200px;
      min-width: 200px;
      height: auto;
      box-shadow: -4px 4px 32px 0px #79919c80;
      margin: 32px;
      transition: transform 0.3s ease;
    }
  }

  .description {
    display: flex;
    flex-direction: column;
    gap: 25px;

    .text {
      font-family: Montserrat;
      font-weight: 400;
      font-style: Regular;
      font-size: 24px;
      line-height: 1;
      text-align: left;

      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      line-clamp: 3;
      overflow: hidden;

      @media (max-width: 1439px) {
        font-size: 20px;
      }
      @media (max-width: 767px) {
        font-size: 18px;
      }
    }

    .title {
      font-family: Montserrat;
      font-weight: 500;
      font-size: 32px;
      line-height: 1;
      text-align: left;
      margin: 0;
      @media (max-width: 1439px) {
        font-size: 24px;
      }
      @media (max-width: 767px) {
        font-size: 20px;
      }
    }
  }
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  .image.zoomed {
    width: auto;
    height: 100%;
    box-shadow: none;
    margin: 0;
    background-color: #fff;
  }
}
</style>
